import { render, staticRenderFns } from "./main-marks.vue?vue&type=template&id=0c91368c&"
import script from "./main-marks.vue?vue&type=script&lang=js&"
export * from "./main-marks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports